/**
 * 解析 JWT token
 * @param {string} token - JWT token
 * @returns {object|null} 解析後的 payload，如果解析失敗則返回 null
 */
export const parseJwt = (token) => {
    try {
        // JWT token 格式：header.payload.signature
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        )
        return JSON.parse(jsonPayload)
    } catch (error) {
        console.error('JWT 解析失敗:', error)
        return null
    }
} 